import { render } from "./InstanceSetting.vue?vue&type=template&id=2328b961"
import script from "./InstanceSetting.vue?vue&type=script&lang=js"
export * from "./InstanceSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__